
import React from 'react';
import { Truck, ShieldCheck, Clock, CreditCard } from 'lucide-react';
import TranslatedText from '@/TranslatedText';

const CheckoutHero = () => {
  return <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg shadow-sm p-6 mb-8 py-[11px]">
      <h2 className="text-xl font-semibold text-ahavex-blue mb-4">
        <TranslatedText text="Safe & Reliable Checkout" />
      </h2>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="flex items-start space-x-3">
          <div className="bg-white p-2 rounded-full shadow-sm">
            <Truck className="w-5 h-5 text-ahavex-blue" />
          </div>
          <div>
            <h3 className="font-medium">
              <TranslatedText text="Fast Delivery" />
            </h3>
            <p className="text-sm text-gray-600">
              <TranslatedText text="Get your products delivered quickly to your doorstep" />
            </p>
          </div>
        </div>
        
        <div className="flex items-start space-x-3">
          <div className="bg-white p-2 rounded-full shadow-sm">
            <ShieldCheck className="w-5 h-5 text-green-600" />
          </div>
          <div>
            <h3 className="font-medium">
              <TranslatedText text="Secure Payments" />
            </h3>
            <p className="text-sm text-gray-600">
              <TranslatedText text="Your transaction is protected with encrypted security" />
            </p>
          </div>
        </div>
        
        <div className="flex items-start space-x-3">
          <div className="bg-white p-2 rounded-full shadow-sm">
            <Clock className="w-5 h-5 text-amber-500" />
          </div>
          <div>
            <h3 className="font-medium">
              <TranslatedText text="Order Tracking" />
            </h3>
            <p className="text-sm text-gray-600">
              <TranslatedText text="Track your order status in real-time" />
            </p>
          </div>
        </div>
        
        <div className="flex items-start space-x-3">
          <div className="bg-white p-2 rounded-full shadow-sm">
            <CreditCard className="w-5 h-5 text-purple-600" />
          </div>
          <div>
            <h3 className="font-medium">
              <TranslatedText text="Multiple Payment Options" />
            </h3>
            <p className="text-sm text-gray-600">
              <TranslatedText text="Pay with your preferred payment method" />
            </p>
          </div>
        </div>
      </div>
    </div>;
};
export default CheckoutHero;
